module.exports = __webpack_public_path__ + "img/guide07.f6f894c4.jpg";